import { render, staticRenderFns } from "./mainlandorder-list.vue?vue&type=template&id=55997d3b"
import script from "./mainlandorder-list.vue?vue&type=script&lang=ts"
export * from "./mainlandorder-list.vue?vue&type=script&lang=ts"
import style0 from "./mainlandorder-list.vue?vue&type=style&index=0&id=55997d3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports